<template>
  <vg-field
      v-bind="$attrs"
      v-on="$listeners"
      :vertical="files.length > 0"
      :label="label"
  >
    <vg-image-uploader
        class="maximum"
        :file-list="files"
        multiple
        :max-count="1"
        :max-size="10 * 1024 * 1024"
        :before-delete="(file,detail)=>delImg(file,detail,value)"
        :after-read="(file)=>personalPhotoOnAfterRead(file)"
        @oversize="onOversize"
    />
  </vg-field>
</template>

<script>
import {Dialog, Toast} from "vant";
import samplePhotos from "@/assets/myElectronicPass/samplePhotos.png";
import {client} from "@/libraries/http";
import {compressIdCard} from "@/libraries/image-converter";
import AddPhoto from "@/assets/myElectronicPass/addPhoto.svg";
import VgImageUploader from "@/components/Commons/VgImageUploader.vue";
import VgField from "@/components/Commons/VgField.vue";
import idGenerate from "@/libraries/id-generate";

const onAfterRead = (file) => {
  console.log('------------------')
  console.log(file, "uploadFile")
  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', '2');
  formData.append('desciption', '');
  formData.append('systemType', 'SERVER_END');
  console.log(formData, "uploadformData")
  return client.post("/api/h5/file_app/upload", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Disable-Loading': 'Yes'
    }
  }).then(rsp => {
    console.log(rsp)
    return rsp;
  })
};

export default {
  name: "DpApplicationPhotoField",
  components: {
    VgField,
    VgImageUploader,
  },
  props: {
    label: String,
    value: null,
    disabled: Boolean,
  },
  data() {
    return {
      SamplePhotos: samplePhotos,
      imgSrc: AddPhoto,
      files: this.value ? [{url: this.value}] : []
    }
  },
  methods: {
    input(value) {
      this.$emit('input', value)
    },
    delImg() {
      return new Promise((resolve, reject) => {
        Dialog.confirm({
          message: '提示：是否确认删除？'
        }).then(() => {
          // photosOvertimeApplication.splice(detail.index)
          this.files = []
          this.input(null)
          this.$toast.success('删除成功')
          resolve()
        }).catch(error => {
          this.$toast.fail('已取消')
          reject(error)
        })
      })
    },
    personalPhotoOnAfterRead(fileWrapper) {
      const imgId = idGenerate()
      compressIdCard(fileWrapper.file)
          .then(blob => {
            let file = fileWrapper.file;
            this.files = [{
              file,
              id: imgId,
              status: 'uploading',
              message: '上传中...',
            }]
            return new window.File([blob], file.name, {type: file.type})
          })
          .then(file => onAfterRead(file))
          .then(res => {
            this.files = [{
              id: imgId,
              url: res.data,
              status: 'done',
              message: '',
            }]
            this.input(res.data);
          })
          .catch(() => {
            this.files = [{
              id: imgId,
              status: 'failed',
              message: '上传失败',
            }]
          });
    },
    onOversize(file) {
      console.log(file);
      Toast('文件大小不能超过 10MB');
    }
  }
}
</script>

<style scoped>
</style>
